import { FC, Fragment } from "react";
import { gatewayStore } from "../../../contexts/gatewayStore";
import SellOption from "../../CreateProposalWizard/CreateProposal/SellNftProposal/SellOption/SellOption";
import FormButtons from "../../FormButtons/FormButtons";
import Modal from "../../Modal/Modal";
import arrowRight from "../../../assets/arrowRightWhite.svg";
import "./VerificationModal.scss";
import { RestrictionOptionsMap } from "../../../common/constants/civic.constants";
import { RestrictionLocationOptions } from "../../../common/enums/civic.enum";

const VerificationModal: FC<{
  submitAction: () => void;
  onClose: () => void;
}> = ({ onClose, submitAction }) => {
  const { gatekeeperNetwork, setGatekeeperNetwork } = gatewayStore();
  return (
    <Fragment>
      <Modal>
        <div className="verification-modal__content">
          <h3>KYC verification</h3>
          <p className="verification-modal__welcome-info">
            In order to continue the verification process, please select one of
            the following:
          </p>
          <div className="verification-modal__options">
            <SellOption
              title="I am US citizen"
              handleClick={() =>
                setGatekeeperNetwork(
                  RestrictionOptionsMap[RestrictionLocationOptions.OnlyUS]
                    .gatekeeperNetwork
                )
              }
              isActive={
                gatekeeperNetwork.toString() ===
                RestrictionOptionsMap[
                  RestrictionLocationOptions.OnlyUS
                ].gatekeeperNetwork.toString()
              }
            />
            <SellOption
              title="I am Non-US citizen"
              handleClick={() =>
                setGatekeeperNetwork(
                  RestrictionOptionsMap[RestrictionLocationOptions.ProhibitUS]
                    .gatekeeperNetwork
                )
              }
              isActive={
                gatekeeperNetwork.toString() ===
                RestrictionOptionsMap[
                  RestrictionLocationOptions.ProhibitUS
                ].gatekeeperNetwork.toString()
              }
            />
          </div>
          <hr />
          <FormButtons
            cancelLabel="Cancel"
            disabled={false}
            onCancel={onClose}
            submitLabel="Proceed to verification"
            typeCancel="button"
            typeSubmit="button"
            submitIcon={arrowRight}
            onSubmit={submitAction}
          />
        </div>
      </Modal>
    </Fragment>
  );
};

export default VerificationModal;
